export default __webpack_public_path__ + "static/opinion-4-4ca23a6bd782df2536c3bd10b804532c.jpg";